import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { getUserRole } from "../../utils/tokenUtils";
import SidebarBrand from "../sidebarBrand/SidebarBrand";
import Sidebar from "../sidebar/Sidebar";
import AddTeamMember from "../addTeamMember/AddTeamMember";
import Dashboard from "../dashboard/Dashboard";
import BrandVoice from "../brandVoice/BrandVoice";
import TaskHistory from "../taskHistory/TaskHistory";
import Support from "../support/Support";
import Task from "../Task/Task";

import "../mainContainer/MainContainer.css";
import ThirdPartyApps from "../apps/ManageShopifyApp";
import AppsList from "../apps/AppsList";
import { ThirdPartyAppsService } from "../../services/thirdPartyApps/thirdPartyAppsService";

const Apps: React.FC = () => {
  const role = getUserRole();
  const location = useLocation();
  const navigate = useNavigate();
  const [hasOptimizelyApp, setHasOptimizelyApp] = useState(false);

  useEffect(() => {
    async function checkOptimizelyApp() {
      try {
        const res = await ThirdPartyAppsService.getApps();
        const appsList = res.data?.data || [];
        setHasOptimizelyApp(
          appsList.some((a) => a.name.toLowerCase().includes("optimizely"))
        );
      } catch (_) {}
    }
    checkOptimizelyApp();

    const handleOptimizelyChange = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setHasOptimizelyApp(detail?.connected ?? false);
    };
    window.addEventListener("optimizely-app-changed", handleOptimizelyChange);
    return () => window.removeEventListener("optimizely-app-changed", handleOptimizelyChange);
  }, []);

  const currentTab = location.pathname.split("/")[2] || "";

  const handleTabChange = (tab: string) => {
    const role = getUserRole(); // or use from context/state
    if (role === "Admin") {
      navigate(`/admin/${tab}`);
    } else {
      navigate(`/user/${tab}`);
    }
  };

  const SidebarComponent = role === "Admin" ? SidebarBrand : Sidebar;

  return (
    <div className="app-container" style={{ display: "flex" }}>
      <SidebarComponent activeTab={currentTab} setActiveTab={handleTabChange} hasOptimizelyApp={role === "Admin" && hasOptimizelyApp} />

      <div className="main-content" style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<AppsList />} />

          <Route path="dashboard" element={<Dashboard />} />

          {role === "admin" ? (
            <Route path="brand" element={<BrandVoice activeTab="brand" />} />
          ) : (
            <Route path="tasks" element={<Task activeTab="tasks" />} />
          )}

          <Route
            path="taskhistory"
            element={<TaskHistory activeTab="taskhistory" />}
          />
          {/* <Route path="support" element={<Support />} /> */}

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/main" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Apps;
